import { Modal } from 'components/organisms/Modal';
import { useFormik } from 'formik';
import { Button, Icon, RadioButton } from 'legacy-components/componets';
import { FC, useState } from 'react';
import {
  RejectOfferModalByLandlordModalFormValues,
  RejectOfferModalByLandlordModalProps,
} from './RejectOfferModalByLandlord.types';
import { rejectReasons, TITLE } from './RejectOfferModalByLandlord.const';
import { isNotEmptyString } from 'common/utils/check-empty-string';
import RadioGroup from 'legacy-components/fields/radio-group/radio-group';

const initialFormValues = {
  rejectionReason: '',
};

export const RejectOfferModalByLandlordModal: FC<RejectOfferModalByLandlordModalProps> = ({
  isOpen,
  isSubmitting,
  onClose,
  onSubmit: sendOffer,
  offerId,
}) => {
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const handleCloseModal = () => {
    onClose();
    setRejectionReason('');
  };

  const onSubmit = async () => {
    await sendOffer({
      applicationId: offerId,
      reason: rejectionReason,
    });
    onClose();
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRejectionReason(e.currentTarget?.value);
  }

  return (
    <Modal
      title={<div className='text-xl'>{TITLE}</div>}
      isOpen={isOpen}
      onClose={handleCloseModal}
      contentClassName={'w-[500px]'}
      footer={
        <div className='flex gap-3 justify-end'>
          <Button label={'Cancel'} theme={'secondary'} onClick={handleCloseModal} className={'w-full sm:w-auto'} />
          <Button
            label={'Reject'}
            theme={'red'}
            disabled={!rejectionReason}
            onClick={onSubmit}
            isLoading={isSubmitting}
            className={'w-full sm:w-auto'}
          />
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <div className='flex text-neutral-800 text-[18px] font-bold leading-snug'>
          <Icon name='danger' width={20} height={20} /> <p className='pl-2'>You have selected to reject the offer. Please let us know the reason of rejection:</p>
        </div>
        <div>
        {rejectReasons.map((item) => (
          <RadioButton key={item}
            name={item} 
            label={item} 
            value={item}
            checked={item === rejectionReason}
            disabled={isSubmitting}
            onChange={handleChange} />
          ))}
        </div>
      </div>
    </Modal>
  );
};
